import { useEffect, useState } from 'react'

const UseEnbekEcoSystemLink = (lang) => {
	const [refEnbek, setRefEnbek] = useState()
	const [refSkills, setRefSkills] = useState()
	const [refBusiness, setBusiness] = useState()
	const [refCareer, setCareer] = useState()
	const [refMigration, setMigration] = useState()
	const [refMansap, setMansap] = useState()

	useEffect(() => {
		const prefix = lang === 'rus' ? 'ru' : 'kk'
		setRefEnbek(process.env.REACT_APP_REDIRECT_ENBEK + prefix)
		setRefSkills(process.env.REACT_APP_REDIRECT_SKILLS + prefix)
		setBusiness(process.env.REACT_APP_REDIRECT_BUSINESS)
		setCareer(process.env.REACT_APP_REDIRECT_CAREER + prefix)
		setMigration(process.env.REACT_APP_REDIRECT_MIGRATION)
		setMansap(process.env.REACT_APP_REDIRECT_MANSAP)
	}, [lang])

	return { refEnbek, refSkills, refBusiness, refCareer, refMigration, refMansap }
}

export default UseEnbekEcoSystemLink
